var map = {
	"./half_pitch_black.png": 63800,
	"./half_pitch_blue.png": 24009,
	"./half_pitch_green.png": 53440,
	"./half_pitch_grey.png": 76296,
	"./half_pitch_white.png": 74658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65288;